<template>
    <div id="app">

        <div class="container-fluid">
          <div class="row">
            <router-view></router-view>
          </div>
        </div><!-- /.container -->
        
    </div> <!-- app -->
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'App',
        data() {
            return {
                msg: 'The App'
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// App.vue?6dd3f309